import { createNotificationsApi } from '@d-orca/shared/client/apis';
import { authedFetch } from '@apis/auth';

export type { Notification, CommsUnreadNotification, NotificationsResponse } from '@interfaces/INotificationsApi';

// The shared notifications API bound to the web transport (cookie
// `authedFetch`); mobile binds the same factory to its Bearer transport.
// Exported whole for `clientApis.ts`, which hands it to the shared hooks.
export const notificationsApi = createNotificationsApi(authedFetch);
export const { fetchNotifications } = notificationsApi;
